import { CheckOutlined, CloseOutlined, EyeOutlined, ExportOutlined, BarChartOutlined } from "@ant-design/icons";
import { message, PageHeader, Popconfirm, Tooltip, Badge } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, ModalItem, TextAreaItem, Form, FormItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import HiloMensajesSoporte from "../../Panel/Soporte/Chat/HiloMensajesSoporte";
import InfoReporte from "../../Panel/Soporte/Chat/InfoReporte";
import FormularioAprobacionJira from "../../Panel/Soporte/Chat/FormularioAprobacionJira";
import BandejaSoporteMovil from "./BandejaSoporteMovil";
import TagFase from "../../Panel/Soporte/Chat/TagFase";
import TagRespuestaCliente from "../../Panel/Soporte/Chat/TagRespuestaCliente";
import { nombreDeUsuario } from "../../Panel/Soporte/Chat/nombreUsuario";
import { SOPORTE_TEMA, TIPOS_INCIDENCIA, chatCerrado, textoChatCerradoAgente } from "../../Panel/Soporte/Chat/fasesSoporte";
import { wsSoporteConectado } from "../../Panel/Soporte/Chat/estadoWsSoporte";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const OPCIONES_FASE = [
    { label: "Todos", value: "todos" },
    { label: "Pre-reporte", value: "pre_reporte" },
    { label: "Cerrado", value: "rechazado" },
    { label: "Por hacer", value: "por_hacer" },
    { label: "En curso", value: "en_curso" },
    { label: "Resuelto", value: "resuelto" },
    { label: "Subido", value: "subido" },
];

const etiquetasPorDefecto = (ticket) => {
    const nombre = ticket?.empresaId?.nombre?.trim();
    return nombre ? [nombre.replace(/\s+/g, "_")] : [];
};

const ANCHO_MOVIL = 1000;
const PAGINA_MOVIL = 20;

const fechaActividad = (t) => new Date(t.ultimoMensajeFecha || t.createdAt).getTime();

const fusionarTickets = (previos, nuevos) => {
    const porId = new Map(previos.map((t) => [String(t._id), t]));
    nuevos.forEach((t) => porId.set(String(t._id), t));
    return Array.from(porId.values()).sort((a, b) => fechaActividad(b) - fechaActividad(a));
};


class TicketsSoporte extends Component {
    tableRef = null;
    formRefRechazo = React.createRef();
    state = {
        tickets: [],
        loading: false,
        totalRecords: 0,
        faseFiltro: "todos",
        modalVisible: false,
        ticketSeleccionado: null,
        mensajes: [],
        loadingMensajes: false,
        enviandoMensaje: false,
        modalRechazoVisible: false,
        pasosReproduccion: "",
        aprobando: false,
        rechazando: false,
        tiposIncidencia: [],
        tipoIncidenciaId: undefined,
        epics: [],
        epicKey: undefined,
        etiquetasDisponibles: [],
        etiquetas: [],
        adjuntarImagenesJira: false,
        prioridades: [],
        prioridadId: undefined,
        incluirInfoUsuario: true,
        jiraBaseUrl: "",
        bitacoraTicket: [],
        isMobile: window.innerWidth <= ANCHO_MOVIL,
        paginaMovil: 1,
        hayMasMovil: false,
        cargandoMasMovil: false,
    };

    componentDidMount() {
        window.addEventListener("soporte_event", this.onSoporteEvent);
        this.intervaloRespaldo = setInterval(this.refrescoDeRespaldo, 12000);
        document.addEventListener("visibilitychange", this.refrescoDeRespaldo);

        window.addEventListener("resize", this.onResize);
        if (this.state.isMobile) this.consultarBandejaMovil({ pagina: 1, reemplazar: true });

        // Catálogos de Jira para los selects de tipo de incidencia, épica, etiquetas y prioridad.
        const headers = { headers: this.props.headersToken };
        axios.post("soporte/tiposIncidenciaJira", {}, headers).then((res) => {
            if (res.data.success === 2) this.setState({ tiposIncidencia: res.data.tipos || [] });
        });
        axios.post("soporte/epicsJira", {}, headers).then((res) => {
            if (res.data.success === 2) this.setState({ epics: res.data.epics || [] });
        });
        axios.post("soporte/etiquetasJira", {}, headers).then((res) => {
            if (res.data.success === 2) this.setState({ etiquetasDisponibles: res.data.etiquetas || [] });
        });
        axios.post("soporte/prioridadesJira", {}, headers).then((res) => {
            if (res.data.success === 2) this.setState({ prioridades: res.data.prioridades || [] });
        });
    }

    componentWillUnmount() {
        window.removeEventListener("soporte_event", this.onSoporteEvent);
        clearInterval(this.intervaloRespaldo);
        document.removeEventListener("visibilitychange", this.refrescoDeRespaldo);
        window.removeEventListener("resize", this.onResize);
        clearTimeout(this.timeoutResize);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isMobile !== this.state.isMobile) {
            if (this.state.isMobile) {
                this.consultarBandejaMovil({ pagina: 1, reemplazar: true });
            } else {
                this.setState({ tickets: [], paginaMovil: 1, hayMasMovil: false });
            }
        }


        if (this.props.history && this.state.isMobile && this.state.ticketSeleccionado && !this.ticketDeLaUrl()) {
            this.cerrarModal();
        }
    }

    onResize = () => {
        clearTimeout(this.timeoutResize);
        this.timeoutResize = setTimeout(() => {
            const isMobile = window.innerWidth <= ANCHO_MOVIL;
            if (isMobile !== this.state.isMobile) this.setState({ isMobile });
        }, 200);
    };

    ticketDeLaUrl = () => new URLSearchParams(this.props.location?.search || "").get("ticket");

    refrescoDeRespaldo = () => {
        if (document.visibilityState !== "visible" || wsSoporteConectado()) return;
        const abierto = this.state.ticketSeleccionado;
        if (this.state.modalVisible && abierto) {
            this.cargarMensajes(abierto._id, { silencioso: true });
        }
    };

    onSoporteEvent = (e) => {
        const data = e.detail || {};
        const abierto = this.state.ticketSeleccionado;
        const esElAbierto = !!abierto && String(data.ticketId) === String(abierto._id);
        const leyendoAhora =
            esElAbierto && this.state.modalVisible && document.visibilityState === "visible";

        if (leyendoAhora) {
            this.cargarMensajes(abierto._id, { silencioso: true });
        }

        if (data.tipo === "nota_interna") return;

        if (data.tipo !== "mensaje") {
            this.refrescar();
            return;
        }

        this.setState((prev) => {
            const tickets = prev.tickets.map((t) =>
                String(t._id) === String(data.ticketId)
                    ? {
                        ...t,
                        ultimoMensajeTexto: data.texto,
                        ultimoMensajeFecha: new Date(),
                        noLeidosSoporte: data.esAgente || leyendoAhora ? 0 : (t.noLeidosSoporte || 0) + 1,
                    }
                    : t,
            );
            if (!prev.isMobile) return { tickets };
            return { tickets: tickets.sort((a, b) => fechaActividad(b) - fechaActividad(a)) };
        });
    };

    consultarBandejaMovil = ({ pagina, reemplazar }) => {
        const { faseFiltro } = this.state;
        this.setState(pagina > 1 ? { cargandoMasMovil: true } : { loading: true });
        axios
            .post(
                "soporte/bandejaSoporte",
                {
                    page: pagina,
                    pageSize: PAGINA_MOVIL,
                    filters: faseFiltro === "todos" ? {} : { fase: faseFiltro },
                    sortField: "ultimoMensajeFecha",
                    sortOrder: "descend",
                },
                { headers: this.props.headersToken },
            )
            .then((res) => {
                if (res.data.success !== 2) {
                    this.setState({ loading: false, cargandoMasMovil: false });
                    message.info(res.data.message || "Los reportes no se cargaron, intenta de nuevo.");
                    return;
                }
                this.setState((prev) => {
                    const recibidos = res.data.tickets || [];
                    const tickets = reemplazar ? recibidos : fusionarTickets(prev.tickets, recibidos);
                    const totalRecords = res.data.totalRecords || 0;
                    return {
                        loading: false,
                        cargandoMasMovil: false,
                        tickets,
                        totalRecords,
                        jiraBaseUrl: res.data.jiraBaseUrl || "",
                        paginaMovil: reemplazar ? 1 : Math.max(prev.paginaMovil, pagina),
                        hayMasMovil: tickets.length < totalRecords,
                    };
                });
            });
    };

    cargarMasMovil = () => this.consultarBandejaMovil({ pagina: this.state.paginaMovil + 1 });

    consultarBandeja(params) {
        this.setState({ loading: true });
        const { fase, ...resto } = params;
        axios
            .post(
                "soporte/bandejaSoporte",
                {
                    ...resto,
                    filters: { ...resto.filters, ...(fase && fase !== "todos" ? { fase } : {}) },
                },
                { headers: this.props.headersToken },
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    this.setState({
                        tickets: res.data.tickets || [],
                        totalRecords: res.data.totalRecords || 0,
                        jiraBaseUrl: res.data.jiraBaseUrl || "",
                    });
                } else {
                    message.info(res.data.message || "Los reportes no se cargaron, intenta de nuevo.");
                }
            });
    }

    cambiarFiltroFase = (value) => {
        this.setState({ faseFiltro: value }, () => {
            if (this.state.isMobile) {
                this.consultarBandejaMovil({ pagina: 1, reemplazar: true });
            } else if (this.tableRef) {
                this.tableRef.updateExternalFilters({ fase: value === "todos" ? undefined : value });
            }
        });
    };

    refrescar = () => {
        if (this.state.isMobile) {
            this.consultarBandejaMovil({ pagina: 1 });
            return;
        }
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ fase: this.state.faseFiltro === "todos" ? undefined : this.state.faseFiltro });
        }
    };

    volverALista = () => {
        if (this.ticketDeLaUrl() && this.props.history) this.props.history.goBack();
        else this.cerrarModal();
    };

    verTicket = (ticket) => {
        if (this.state.isMobile && this.props.history && this.ticketDeLaUrl() !== String(ticket._id)) {
            this.props.history.push({ search: `?ticket=${ticket._id}` });
        }
        this.setState({
            modalVisible: true,
            ticketSeleccionado: ticket,
            pasosReproduccion: ticket.pasosReproduccion || "",
            tipoIncidenciaId: undefined,
            epicKey: undefined,
            etiquetas: etiquetasPorDefecto(ticket),
            adjuntarImagenesJira: false,
            prioridadId: undefined,
            incluirInfoUsuario: true,
            // Abrirlo cuenta como leerlo
            tickets: this.state.tickets.map((t) =>
                String(t._id) === String(ticket._id) ? { ...t, noLeidosSoporte: 0 } : t,
            ),
        });
        this.cargarMensajes(ticket._id);
        this.cargarBitacoraTicket(ticket._id);
    };

    // Historial de auditoría del reporte: quién lo aprobó/rechazó y qué respondió
    // el cliente. Va por endpoint aparte porque la bitácora de la empresa filtra
    // por empresaId y no alcanza los reportes hechos sin empresa.
    cargarBitacoraTicket = (ticketId) => {
        this.setState({ bitacoraTicket: [] });
        axios
            .post("soporte/bitacoraTicket", { ticketId }, { headers: this.props.headersToken })
            .then((res) => {
                if (res.data.success === 2) this.setState({ bitacoraTicket: res.data.movimientos || [] });
            })
            .catch(() => {
                // Silencioso: el historial es informativo, no bloquea la gestión del ticket.
            });
    };

    cargarMensajes = (ticketId, { silencioso } = {}) => {
        if (!silencioso) this.setState({ loadingMensajes: true });
        axios
            .post("soporte/obtenerMensajes", { ticketId }, { headers: this.props.headersToken })
            .then((res) => {
                if (!silencioso) this.setState({ loadingMensajes: false });
                if (res.data.success === 2) {
                    this.setState({ mensajes: res.data.mensajes || [], ticketSeleccionado: res.data.ticket });
                } else if (!silencioso) {
                    message.info(res.data.message || "El chat no se cargó, intenta de nuevo.");
                }
            });
    };

    cerrarModal = () => {
        if (this.state.isMobile && this.props.history && this.ticketDeLaUrl()) {
            this.props.history.replace({ search: "" });
        }
        this.setState({
            modalVisible: false,
            ticketSeleccionado: null,
            mensajes: [],
            modalRechazoVisible: false,
            bitacoraTicket: [],
        });
    };

    enviarMensajeAgente = (texto) => {
        const ticketId = this.state.ticketSeleccionado._id;
        this.setState({ enviandoMensaje: true });
        axios
            .post("soporte/enviarMensaje", { ticketId, texto }, { headers: this.props.headersToken })
            .then((res) => {
                this.setState({ enviandoMensaje: false });
                if (res.data.success === 2) {
                    this.cargarMensajes(ticketId, { silencioso: true });
                } else {
                    message.info(res.data.message || "Tu mensaje no se envió, intenta de nuevo.");
                }
            });
    };

    cambiarValorAprobacion = (campo, valor) => this.setState({ [campo]: valor });

    faltaTipoIncidencia = () => this.state.tiposIncidencia.length > 0 && !this.state.tipoIncidenciaId;

    aprobarTicket = () => {
        if (this.faltaTipoIncidencia()) {
            message.info("Escoge el tipo de incidencia con el que se dará de alta en Jira.");
            return;
        }

        const ticketId = this.state.ticketSeleccionado._id;
        this.setState({ aprobando: true });
        axios
            .post(
                "soporte/aprobarTicket",
                {
                    ticketId,
                    pasosReproduccion: this.state.pasosReproduccion,
                    tipoIncidenciaId: this.state.tipoIncidenciaId,
                    epicKey: this.state.epicKey,
                    etiquetas: this.state.etiquetas,
                    prioridadId: this.state.prioridadId,
                    adjuntarImagenesJira: this.state.adjuntarImagenesJira,
                    incluirInfoUsuario: this.state.incluirInfoUsuario,
                },
                { headers: this.props.headersToken },
            )
            .then((res) => {
                this.setState({ aprobando: false });
                if (res.data.success === 2) {
                    message.success("Ticket aprobado" + (res.data.jiraKey ? ` — Issue de Jira: ${res.data.jiraKey}` : ""));
                    this.cerrarModal();
                    this.refrescar();
                } else {
                    message.info(res.data.message || "El reporte no se aprobó, intenta de nuevo.");
                }
            });
    };

    confirmarRechazo = () => {
        this.formRefRechazo.current.validateFields().then((values) => {
            const ticketId = this.state.ticketSeleccionado._id;
            this.setState({ rechazando: true });
            axios
                .post(
                    "soporte/rechazarTicket",
                    { ticketId, motivoRechazo: values.motivoRechazo },
                    { headers: this.props.headersToken },
                )
                .then((res) => {
                    this.setState({ rechazando: false });
                    if (res.data.success === 2) {
                        message.success("Reporte cerrado");
                        this.cerrarModal();
                        this.refrescar();
                    } else {
                        message.info(res.data.message || "El reporte no se cerró, intenta de nuevo.");
                    }
                });
        });
    };

    render() {
        const columns = [
            {
                title: "Folio",
                dataIndex: "folio",
                key: "folio",
                buscar: "folio",
                width: "10%",
                // Mensajes del cliente que soporte no ha leído.
                render: (folio, record) => (
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <span>{folio}</span>
                        {record.noLeidosSoporte > 0 && (
                            <Tooltip title={record.ultimoMensajeTexto}>
                                <Badge
                                    count={record.noLeidosSoporte}
                                    overflowCount={99}
                                    style={{ backgroundColor: SOPORTE_TEMA.primario }}
                                />
                            </Tooltip>
                        )}
                    </div>
                ),
            },
            {
                title: "Título",
                dataIndex: "titulo",
                key: "titulo",
                buscar: "titulo",
                width: "16%",
            },
            {
                title: "Empresa",
                dataIndex: "empresaId",
                key: "empresaId",
                render: (empresa) => (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: 12, fontWeight: "bold" }}>{empresa?.nombre || "Sin empresa"}</span>
                        {empresa?.usuarioId?.nombreCorporativo && (
                            <span style={{ fontSize: 11, color: "#666" }}>{empresa.usuarioId.nombreCorporativo}</span>
                        )}
                    </div>
                ),
                width: "16%",
            },
            {
                title: "Reportado por",
                dataIndex: "usuarioId",
                key: "usuarioId",
                render: (usuario) => (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: 12 }}>{nombreDeUsuario(usuario)}</span>
                        {usuario?.correo && <span style={{ fontSize: 11, color: "#666" }}>{usuario.correo}</span>}
                    </div>
                ),
                width: "16%",
            },
            {
                title: "Tipo",
                dataIndex: "tipoIncidencia",
                key: "tipoIncidencia",
                filters: Object.entries(TIPOS_INCIDENCIA).map(([value, text]) => ({ text, value })),
                filterMultiple: false,
                render: (tipo) => <span style={{ fontSize: 12 }}>{TIPOS_INCIDENCIA[tipo] || "—"}</span>,
                width: "10%",
            },
            {
                title: "Fase",
                dataIndex: "fase",
                key: "fase",
                // El sí/no del cliente va debajo de la fase: un reporte "subido"
                // que el cliente marcó como no cumplido no se puede ver igual que
                // uno confirmado.
                render: (fase, record) => (
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
                        <TagFase fase={fase} />
                        <TagRespuestaCliente respuesta={record.respuestaCliente} />
                    </div>
                ),
                width: "10%",
            },
            {
                title: "Jira",
                dataIndex: "jiraKey",
                key: "jiraKey",
                buscar: "jiraKey",
                width: "10%",
                render: (jiraKey) => {
                    if (!jiraKey) return <span style={{ color: "#bbb" }}>—</span>;
                    if (!this.state.jiraBaseUrl) return <span style={{ fontSize: 12 }}>{jiraKey}</span>;
                    return (
                        <Tooltip title="Abrir la tarea en Jira">
                            <a
                                href={`${this.state.jiraBaseUrl}/browse/${jiraKey}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{ fontSize: 12, whiteSpace: "nowrap" }}
                            >
                                {jiraKey} <ExportOutlined />
                            </a>
                        </Tooltip>
                    );
                },
            },
            {
                title: "Fecha",
                dataIndex: "createdAt",
                key: "createdAt",
                sorter: true,
                render: (value) => moment(value).format("LLL"),
                width: "12%",
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "8%",
                render: (value, record) => (
                    <Tooltip title="Ver y resolver">
                        <ButtonItem type="default" size="small" azul icon={<EyeOutlined />} onClick={() => this.verTicket(record)} />
                    </Tooltip>
                ),
            },
        ];

        const { ticketSeleccionado, isMobile } = this.state;
        const esPendiente = ticketSeleccionado?.fase === "pre_reporte";
        const cerrado = chatCerrado(ticketSeleccionado?.fase);
        const faltaTipoIncidencia = this.faltaTipoIncidencia();

        const catalogos = {
            tiposIncidencia: this.state.tiposIncidencia,
            epics: this.state.epics,
            prioridades: this.state.prioridades,
            etiquetasDisponibles: this.state.etiquetasDisponibles,
        };
        const valores = {
            pasosReproduccion: this.state.pasosReproduccion,
            tipoIncidenciaId: this.state.tipoIncidenciaId,
            epicKey: this.state.epicKey,
            prioridadId: this.state.prioridadId,
            etiquetas: this.state.etiquetas,
            incluirInfoUsuario: this.state.incluirInfoUsuario,
            adjuntarImagenesJira: this.state.adjuntarImagenesJira,
        };

        const modalRechazo = (
            <ModalItem
                visible={this.state.modalRechazoVisible}
                title="Cerrar reporte"
                onCancel={() => this.setState({ modalRechazoVisible: false })}
                footer={null}
                destroyOnClose
                spinning={false}
                // En celular se abre encima del panel de acciones, que es de antd 5
                // y comparte el z-index por defecto.
                zIndex={isMobile ? 1100 : undefined}
            >
                <Form
                    ref={this.formRefRechazo}
                    name="formRechazoTicket"
                    layout
                    bottom={
                        <div style={{ display: "flex", justifyContent: "right" }}>
                            <ButtonItem type="primary" cyan loading={this.state.rechazando} onClick={this.confirmarRechazo}>
                                Cerrar reporte
                            </ButtonItem>
                        </div>
                    }
                >
                    <FormItem label="Comentario para el cliente" name="motivoRechazo" margin required>
                        <TextAreaItem placeholder="Cuéntale al cliente cómo quedó atendido su reporte" rows={3} />
                    </FormItem>
                </Form>
            </ModalItem>
        );

        if (isMobile) {
            return (
                <>
                    <BandejaSoporteMovil
                        tickets={this.state.tickets}
                        loading={this.state.loading}
                        opcionesFase={OPCIONES_FASE}
                        faseFiltro={this.state.faseFiltro}
                        onCambiarFase={this.cambiarFiltroFase}
                        hayMas={this.state.hayMasMovil}
                        cargandoMas={this.state.cargandoMasMovil}
                        onCargarMas={this.cargarMasMovil}
                        usuarioId={this.props.usuarioId}
                        onSeleccionar={this.verTicket}
                        ticketSeleccionado={ticketSeleccionado}
                        mensajes={this.state.mensajes}
                        loadingMensajes={this.state.loadingMensajes}
                        enviandoMensaje={this.state.enviandoMensaje}
                        onVolver={this.volverALista}
                        onEnviarMensaje={this.enviarMensajeAgente}
                        jiraBaseUrl={this.state.jiraBaseUrl}
                        catalogos={catalogos}
                        valores={valores}
                        onCambiarValor={this.cambiarValorAprobacion}
                        faltaTipoIncidencia={faltaTipoIncidencia}
                        aprobando={this.state.aprobando}
                        rechazando={this.state.rechazando}
                        onAprobar={this.aprobarTicket}
                        onRechazar={() => this.setState({ modalRechazoVisible: true })}
                    />
                    {modalRechazo}
                </>
            );
        }

        return (
            <>
                <PageHeader
                    title="Tickets de Soporte"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                            <SegmentedItem
                                options={OPCIONES_FASE}
                                value={this.state.faseFiltro}
                                onChange={this.cambiarFiltroFase}
                            />
                            <Tooltip title="Métricas del módulo de soporte">
                                <ButtonItem
                                    azul
                                    icon={<BarChartOutlined />}
                                    onClick={() =>
                                        this.props.history?.push("/panelPrincipal/dashboardSoporte")
                                    }
                                >
                                    Métricas
                                </ButtonItem>
                            </Tooltip>
                        </div>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => (this.tableRef = ref)}
                    onRef={(ref) => (this.tableRef = ref)}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarBandeja.bind(this)}
                    size="small"
                    dataSource={this.state.tickets}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"ticketsSoporte"}
                />

                <ModalItem
                    visible={this.state.modalVisible}
                    title={
                        ticketSeleccionado
                            ? `${ticketSeleccionado.folio} — ${ticketSeleccionado.titulo} · ${nombreDeUsuario(
                                  ticketSeleccionado.usuarioId,
                                  "Sin usuario",
                              )}`
                            : ""
                    }
                    onCancel={this.cerrarModal}
                    footer={null}
                    destroyOnClose
                    width={900}
                    spinning={false}
                >
                    {ticketSeleccionado && (
                        <>
                            <div style={{ marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
                                <TagFase fase={ticketSeleccionado.fase} />
                                <TagRespuestaCliente respuesta={ticketSeleccionado.respuestaCliente} />
                                {ticketSeleccionado.jiraKey &&
                                    (this.state.jiraBaseUrl ? (
                                        <a
                                            href={`${this.state.jiraBaseUrl}/browse/${ticketSeleccionado.jiraKey}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ fontSize: 12 }}
                                        >
                                            {ticketSeleccionado.jiraKey} <ExportOutlined />
                                        </a>
                                    ) : (
                                        <span style={{ fontSize: 12, color: SOPORTE_TEMA.textSecondary }}>
                                            {ticketSeleccionado.jiraKey}
                                        </span>
                                    ))}
                            </div>

                            {/* Chat a la izquierda, info del reporte (+ controles de aprobación) a la derecha */}
                            <div style={{ display: "flex", gap: 20 }}>
                                <div
                                    style={{
                                        flex: "1 1 50%",
                                        minWidth: 0,
                                        height: 460,
                                        display: "flex",
                                        border: `1px solid ${SOPORTE_TEMA.border}`,
                                        borderRadius: 6,
                                    }}
                                >
                                    <HiloMensajesSoporte
                                        mensajes={this.state.mensajes}
                                        loading={this.state.loadingMensajes}
                                        enviando={this.state.enviandoMensaje}
                                        onEnviar={this.enviarMensajeAgente}
                                        perspectivaAgente
                                        soloLectura={cerrado}
                                        textoSoloLectura={cerrado ? textoChatCerradoAgente(ticketSeleccionado.fase) : undefined}
                                    />
                                </div>

                                <div style={{ flex: "1 1 50%", minWidth: 0, maxHeight: 460, overflowY: "auto", paddingRight: 4 }}>
                                    <InfoReporte
                                        ticket={ticketSeleccionado}
                                        mostrarPasos={!esPendiente}
                                        mostrarNotasInternas
                                        perspectivaAgente
                                    />

                                    {esPendiente && (
                                        <FormularioAprobacionJira
                                            ticket={ticketSeleccionado}
                                            catalogos={catalogos}
                                            valores={valores}
                                            onCambiar={this.cambiarValorAprobacion}
                                        />
                                    )}

                                    {this.state.bitacoraTicket.length > 0 && (
                                        <div style={{ marginTop: 14 }}>
                                            <div
                                                style={{
                                                    fontSize: 11,
                                                    color: SOPORTE_TEMA.textSecondary,
                                                    textTransform: "uppercase",
                                                    letterSpacing: 0.3,
                                                    marginBottom: 6,
                                                }}
                                            >
                                                Historial de soporte
                                            </div>
                                            {this.state.bitacoraTicket.map((mov) => (
                                                <div
                                                    key={mov._id}
                                                    style={{
                                                        borderLeft: `2px solid ${SOPORTE_TEMA.border}`,
                                                        paddingLeft: 8,
                                                        marginBottom: 8,
                                                        fontSize: 12,
                                                    }}
                                                >
                                                    {mov.detalles || mov.accion}
                                                    <div style={{ fontSize: 10, color: SOPORTE_TEMA.textSecondary }}>
                                                        {mov.usuario}
                                                        {mov.fecha ? ` · ${moment(mov.fecha).format("DD/MM/YYYY HH:mm")}` : ""}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {esPendiente && (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                        gap: 12,
                                        marginTop: 16,
                                        paddingTop: 12,
                                        borderTop: `1px solid ${SOPORTE_TEMA.border}`,
                                    }}
                                >
                                    {faltaTipoIncidencia && (
                                        <span style={{ fontSize: 11, color: SOPORTE_TEMA.textSecondary }}>
                                            Escoge el tipo de incidencia de Jira para poder aprobar
                                        </span>
                                    )}
                                    <ButtonItem
                                        cyanB
                                        icon={<CloseOutlined />}
                                        loading={this.state.rechazando}
                                        onClick={() => this.setState({ modalRechazoVisible: true })}
                                    >
                                        Cerrar reporte
                                    </ButtonItem>
                                    <Popconfirm
                                        title="¿Aprobar este ticket y crear el Issue en Jira?"
                                        onConfirm={this.aprobarTicket}
                                        okText="Sí"
                                        cancelText="No"
                                        disabled={faltaTipoIncidencia}
                                    >
                                        <ButtonItem
                                            verde
                                            icon={<CheckOutlined />}
                                            loading={this.state.aprobando}
                                            disabled={faltaTipoIncidencia}
                                        >
                                            Aprobar
                                        </ButtonItem>
                                    </Popconfirm>
                                </div>
                            )}
                        </>
                    )}
                </ModalItem>

                {modalRechazo}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps)(TicketsSoporte);
